export default {
    en:{
        btn:'Category',
        modalTitle:'Book Publication Categorization and Points',

        foot:{
            line1:'External: Maximum points that can be given for publications that have been approved by an external evaluation for the process of publication substitution ',
            line2:'Internal: Maximum points that can be given for publications that have approved by the Department or College Personnel Committee, without an approval of an external evaluation ',
            line3:'Above Rank 50: Maximum points that can be given to publications that have been published by University Press of Rank 50 or above ',
            line4:'Above Rank 100: Maximum points that can be given to publications that have been published by University Press of Rank 100 or above',
            line5:'※ Please refer to the Faculty Performance Evaluation Detailed Rules [Attachment Table 5 and 6].',
        },

        gubunTable:{
            tableTitle:'1. Book Publication Categorization',
            gubun:'Category',
            pro:'Professional Publications',
            liberal:'General Publications',
            write:'Books',
            translate:'Translated Books',
            edit:'Edited Books',

            proA:'Professional Academic Publication A: Original and professional publications where more than 50% of the content consists of newly published information in addition to previously published materials; Up to 3 co-authors are permitted; Class of readers include researchers in the same field of studies.',
            proB:'Professional Academic Publication B: Professional publications where between 30-50% of the content consists of newly published information in addition to previously published materials; Class of readers include researchers in the same field of studies; Includes textbooks, introductory books, collection of essays, professional academic dictionaries that can be recognized as a result of social science research. ',
            liberalPub:'General Publications: Publications that are related to the field of studies; May be opinion and essay-based; Class of readers included non-academic scholars.',
            proTranslate:'Professional Translation: Classical resources or professional academic publications that are related to the faculty member\'s field of studies, which have been translated and annotated through his or her creative analysis. ',
            generalTranslate:'General Translation: Complete translation of books with an academic and educational objective.',
            complication:'Edited Books/Manuals: Publications such as source books, index books, dictionaries of social science fields, that edited professional journals on a specific field of studies; The faculty member\'s journal in the edited books shall be of domestic or international Tier 4.',
            dictionary:'Dictionaries (Compilation or Supervision): Compiling or supervising a language dictionary that have been compiled based on the field of studies that is related to the faculty member\'s field of studies. Only applies to faculty members in the field of language from the College of Humanities. For others, they shall be classified as a Professional Academic Publication B or a manual. ',
        },

        scoreTable:{
            tableTitle:'2. Maximum points for each research field and publication category ',
            gubun:'Research \nField  \n/ Publication \nCategory ',
            dom:'Domestic',
            inter:'International',
            in:'Internal',
            out:'External',
            top50:'Above \nRank \n50',
            top100:'Above \nRank \n100',
            hss:'Humanities/Social Sciences\n/Arts, Music & Health Sciences',
            stem:'Natural Sciences \n& Engineering',

            proA:'Professional \nAcademic \nPublication A',
            proB:'Professional \nAcademic \nPublication B',
            liberalPub: 'General \nPublication',
            proTranslate: 'Professional \nTranslation',
            generalTranslate: 'General \nTranslation',
            complication: 'Edited \nBooks/Manuals',
            dictPublish: 'Dictionary \nCompilation',
            dictSupervise: 'Dictionary \nSupervision',
        }
    },
    ko:{
        btn:'저역서구분기준',
        modalTitle:'[저역서의 구분 및 평점]',

        foot:{
            line1:'※ 외부: 저술에 대한 외부심사를 거쳐 대체편수인정절차를 완료한 경우 부여할 수 있는 최대 평점',
            line2:'내부: 저술에 대한 외부심사를 거치지 않고 학과(학부 또는 전공)인사위원회의 심사에 의해 부여할 수 있는 최대 평점',
            line3:'50대: 세계 50대 대학 출판사에서 출간된 경우 부여할 수 있는 최대 평점',
            line4:'100대: 세계 100대 대학 출판사에서 출간된 경우 부여할 수 있는 최대 평점',
            line5:'※ 저역서의 분류, 평가, 평점 등에 대한 상세 사항은 교원업적평가시행세칙 별표5와 별표6을 참조하여 주시기 바랍니다.',
        },

        gubunTable:{
            tableTitle:'1. 저술의 구분',
            gubun:'구분',
            pro:'전문서',
            liberal:'교양서',
            write:'저서',
            translate:'번역서',
            edit:'편저서',

            proA:'전문학술서A: 자신의 전공에 관한 독창적이고 전문적인 저술로서, 기존의 논문이나 저술로 발표된 내용 외에 새로운 연구가 50% 이상을 넘는 새로운 글로 된 저술로서 저자수는 3인이하. 대상 독자층은 동일 학문분야 연구자',
            proB:'전문학술서B: 자신의 전공에 관한 전문적인 저술로서, 기존의 논문이나 저술로 발표된 내용 외에 새로운 연구가 30%~50%인 저술. 대상 독자층은 동일학문분야 연구자. 교과서, 개론서, 총론서, 사회분야의 연구결과로 인정할 수 있는 전문학술사전 등을 포함함.',
            liberalPub:'교양서: 학문분야와 관련된 에세이적인 성격으로 쓴 저서 혹은 시국에 관한 주의, 주장 등을 담은 저술. 대상 독자층은 일반인',
            proTranslate:'전문번역: 자신의 전공과 밀접한 고전자료나 전문학술서를 충분한 학문적 축적을 통해 역주하거나 자신이 전공하는 문학작품을 독창적인 해석을 통하여 해제하고 번역한 책',
            generalTranslate:'일반번역: 학술과 교육목적이 분명한 학술서의 완역서',
            complication:'편저·공구(工具)서: 전공에 관한 일정한 전문적인 주제의 학술논문을 편집하고 전체적인 내용을 조망하는 서문을 집필한 저술 및 자료집, 색인집, 사회분야의 사전류의 편찬. 편저서에 실린 자신의 논문은 국내4등급 혹은 국제4등급으로 함.',
            dictionary:'사전(편찬 혹은 감수): 자신의 전공과 관련된 학술적 연구를 토대로 편찬된 언어사전에 대한 편찬 혹은 감수.  인문분야 중 어학분야 교원에게만 부여한다. 그 외의 경우 전문학술서B나 공구서로 분류하여야 한다.',
        },

        scoreTable:{
            tableTitle:'2. 업적분야 및 저술구분에 따른 최대 평점',
            gubun:'업적분야\n저술구분',
            dom:'국내',
            inter:'국제',
            in:'내부',
            out:'외부',
            top50:'50대',
            top100:'100대',
            hss:'인문/사회/예체능분야',
            stem:'이학, 공학분야',

            proA:'전문학술서A',
            proB:'전문학술서B',
            liberalPub: '교양서',
            proTranslate: '전문번역',
            generalTranslate: '일반번역',
            complication: '편저·공구서',
            dictPublish: '사전편찬',
            dictSupervise: '사전감수',
        }
    }
}